import { trpc } from '@/shared/api/trpc';

export const useSubitemTemplates = (parentId: string) =>
  trpc.products.subitemTemplates.useQuery({ parentId });
